import wrapInObserver from '../wrapInObserver';
import Claims from './Claims';
import {
  makePassportClaimsArchiveUrl,
  makePassportClaimsToUrl,
} from '../../utils/urlProvider';
import generatedHooks from '../../hooks/generatedHooks';

const {
  useUiStore,
} = generatedHooks;

const mapProps = ({ row }) => {
  const { claims } = row;
  const { firm } = row;

  const {
    isMobile,
  } = useUiStore(store => store);

  const {
    activeClaimsCount,
    activeClaimsSum,
    closedClaimsCount,
  } = claims;

  const { atiId } = firm;

  const visible = closedClaimsCount || activeClaimsCount;
  const claimsToUrl = makePassportClaimsToUrl(atiId);
  const claimsArchiveUrl = makePassportClaimsArchiveUrl(atiId);

  return {
    visible,
    activeClaimsSum,
    activeClaimsCount,
    closedClaimsCount,
    claimsToUrl,
    claimsArchiveUrl,
    isMobile,
  };
};

export default wrapInObserver(Claims, mapProps);
